export enum TipoDepositoDevolucaoEnum {
  MesmoDepositoVendaNota = 1,
  DepositoPrincipal = 2,
  DepositoEspecifico = 3,
}
